export default "__VITE_ASSET__45f27783__"